const validPasswordLength = (password: string) => {
  return password.length >= 8;
};

const isPasswordValid = (password: string) => {
  return validPasswordLength(password);
};

export { validPasswordLength, isPasswordValid };
